/*
 * lyvoi-second-item.js — Lyvoi PDP Duo / Triple card price
 * 2026-10-12: Duo changed from "both cases 10% off" to "2nd (lower-priced) case 15% off"
 * (Shopify automatic discount "2ND CASE 15% OFF", BXGY). The theme's quantity-break card
 * prices bundles as sum x percentage, which can't express that, so this rewrites the Duo
 * card price to: higher price + 0.85 x lower price — exactly what checkout charges.
 * 2026-10-22: 3+ cases changed from "25% off every case" to "1st full, 2nd 15% off, 3rd+ 25% off",
 * charged as per-count automatic discounts "N-CASE BUNDLE SAVINGS" (same % on every unit).
 * Checkout floors the discount per unit to the cent, so the Triple card does the same.
 * qty-break-price-sync.js then mirrors the card into the main/sticky price as before.
 * DISPLAY-ONLY. Never touches the form or cart. Any failure is silent (theme price stays).
 */
(function () {
  'use strict';
  var TIER_PCT = { 3: 0.1334 };
  function money(cents) {
    var d = Math.round(cents) / 100;
    var s = d % 1 === 0 ? String(d) : d.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function variantPrice(color, size) {
    try {
      var vs = window.ShopifyAnalytics.meta.product.variants;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].public_title === color + ' / ' + size) return vs[i].price;
      }
    } catch (e) {}
    return null;
  }
  function prices(label, n) {
    var cs = label.querySelectorAll('select[name="options[Color]"]');
    var ss = label.querySelectorAll('select[name="options[Size]"]');
    if (cs.length < n || ss.length < n) return null;
    var out = [];
    for (var i = 0; i < n; i++) {
      var p = variantPrice(cs[i].value, ss[i].value);
      if (p == null) return null;
      out.push(p);
    }
    return out;
  }
  function desired(label, n) {
    var ps = prices(label, n);
    if (!ps) return null;
    if (n === 2) return money(Math.max(ps[0], ps[1]) + 0.85 * Math.min(ps[0], ps[1]));
    var total = 0;
    // +1e-6: 30000 * 0.1334 = 4001.9999… in floats, checkout takes 40.02
    ps.forEach(function (p) { total += p - Math.floor(p * TIER_PCT[n] + 1e-6); });
    return money(total);
  }
  function fix() {
    try {
      [2, 3].forEach(function (n) {
        var label = document.querySelector('.quantity-break[data-quantity="' + n + '"]');
        if (!label) return;
        var el = label.querySelector('.quantity-break__price');
        var want = desired(label, n);
        if (el && want && el.textContent.trim() !== want) el.textContent = want;
      });
    } catch (e) { /* silent */ }
  }
  function boot() {
    try {
      fix();
      // theme rewrites the card price on every variant change; re-apply right after it does
      [2, 3].forEach(function (n) {
        var label = document.querySelector('.quantity-break[data-quantity="' + n + '"]');
        var el = label && label.querySelector('.quantity-break__price');
        if (el) new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true });
      });
      document.addEventListener('change', function () { setTimeout(fix, 0); }, true);
    } catch (e) { /* silent */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
